import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { BottomNav } from "@/components/BottomNav";
import { QuickCapture } from "@/components/QuickCapture";

export const Layout: React.FC = () => {
  const [capture, setCapture] = useState(false);
  const location = useLocation();

  return (
    <div className="relative mx-auto w-full max-w-md min-h-screen bg-cream overflow-x-hidden shadow-[0_0_80px_rgba(33,38,33,0.08)]">
      <main className="px-6 pt-14 pb-36 min-h-screen">
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>

      <BottomNav onCapture={() => setCapture(true)} />
      <QuickCapture open={capture} onClose={() => setCapture(false)} />
    </div>
  );
};
